import { useMutation } from "@apollo/client";
import type {
  UpdateConnectionInput,
  UpdateConnectionPayload,
} from "@casey/db-types";
import { UPDATE_INTERVIEW_INVITE_TEMPLATE } from "../gql";

export interface UpdateConnectionTemplateVariables {
  input: UpdateConnectionInput;
}

export interface UpdateConnectionTemplateData {
  updateConnection: UpdateConnectionPayload;
}

export function useUpdateConnectionTemplate() {
  const [updateTemplate, { loading, error }] = useMutation<
    UpdateConnectionTemplateData,
    UpdateConnectionTemplateVariables
  >(UPDATE_INTERVIEW_INVITE_TEMPLATE);

  const updateInviteTemplate = async (
    connectionCode: string,
    agentId: string,
  ) => {
    try {
      const result = await updateTemplate({
        variables: {
          input: {
            connectionCode,
            patch: {
              agentId,
            },
          },
        },
      });

      return result.data?.updateConnection?.connection;
    } catch (err) {
      console.error("Error updating invite template:", err);
      throw err;
    }
  };

  return {
    updateInviteTemplate,
    loading,
    error,
  };
}
